import { liquidGlassRowShadowSx, liquidGlassSurfaceFillSx } from '@focuslee/shared-mini-app';
import { Box } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';

interface RatingPromptProps {
    promptText?: string | null;
}

export const RatingPrompt: FC<RatingPromptProps> = ({ promptText }) => {
    if (!promptText) return null;

    return (
        <Box sx={{ marginBottom: '24px', borderRadius: '12px', overflow: 'hidden', ...liquidGlassRowShadowSx }}>
            <Box sx={{ borderRadius: 'inherit', padding: '16px', ...liquidGlassSurfaceFillSx }}>
                <Text style={{ fontSize: '16px', color: 'var(--tg-theme-text-color)' }}>
                    {promptText}
                </Text>
            </Box>
        </Box>
    );
};
